'use strict';
import {combineReducers} from 'redux';
import {reduxList as assetProjectList} from '../redux/assetProjectList';
import {createProjectRequest} from '../redux/createProject';
import {deleteAssetProjectRequest} from '../redux/deleteAssetProject';
import {deleteProjectRequest} from '../redux/deleteProject';
import {
  ASSET_LIST_NAME,
  CREATE_PROJECT_NAME,
  DELETE_ASSET_PROJECT_NAME,
  DELETE_PROJECT_NAME,
  UPDATE_PROJECT_NAME,
} from '../redux/state';
import {updateProjectRequestModal} from '../redux/updateProject';


export * from './state';

export const projects = combineReducers({
  [ASSET_LIST_NAME]: assetProjectList.reducers.reducer,
  [CREATE_PROJECT_NAME]: createProjectRequest.reducers.reducer,
  [DELETE_ASSET_PROJECT_NAME]: deleteAssetProjectRequest.reducers.reducer,
  [DELETE_PROJECT_NAME]: deleteProjectRequest.reducers.reducer,
  [UPDATE_PROJECT_NAME]: updateProjectRequestModal.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/projects/reducers/index.js